import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { formatMoney } from 'accounting-js';

const CardPrice = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  fontFamily: theme.font.caption,
  fontSize: 12,
  justifyContent: 'center',
  letterSpacing: 2,
  lineHeight: 1.4,
  textTransform: 'uppercase',
  [`@media screen and (min-width: ${theme.breakpoint.large})`]: {
    flexDirection: 'row'
  }
}));

const PriceOriginal = styled.span(() => (null));

const PriceSale = styled.span(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [PriceOriginal]: {
    color: theme.color.brand,
    marginRight: '0.5rem',
    position: 'relative',
    '::before': {
      content: '""',
      width: '100%',
      height: 1,
      background: theme.color.brand,
      opacity: 0.5,
      position: 'absolute',
      left: 0,
      top: '50%'
    }
  },
  [`@media screen and (min-width: ${theme.breakpoint.large})`]: {
    '::after': {
      content: '"|"',
      margin: '0 0.5rem',
      display: 'inline-block'
    }
  }
}));

const PricePercentage = styled.span(({ theme }) => ({
  color: theme.color.brandA11yRed
}));

const Price = ({ hit, ...props }) => {
  const {
    niceprice,
    min,
    max,
    on_sale,
    percent_off
  } = hit;
  // We'll conditionally re-assign these, so `let`
  let { price_min, price_max } = hit;
  price_min = price_min ?? min ?? 0;
  price_max = price_max ?? max ?? 0;

  if (on_sale && percent_off) {
    if (price_min !== price_max) {
      return (
        <CardPrice {...props}>
          <PriceSale>{`${formatMoney(price_min)} - ${formatMoney(price_max)}`}</PriceSale>
          <PricePercentage>{`UP TO ${percent_off}% OFF`}</PricePercentage>
        </CardPrice>
      );
    }

    return (
      <CardPrice {...props}>
        <PriceSale>
          <PriceOriginal>
            {formatMoney(price_min / (1 - (percent_off / 100)))}
          </PriceOriginal>
          {formatMoney(price_min)}
        </PriceSale>

        <PricePercentage>
          {percent_off}
          % Off
        </PricePercentage>
      </CardPrice>
    );
  }

  if (price_min !== price_max) {
    return (
      <CardPrice {...props}>
        <PriceOriginal>{`${formatMoney(price_min)} - ${formatMoney(price_max)}`}</PriceOriginal>
      </CardPrice>
    );
  }

  return <CardPrice {...props}>{niceprice ?? formatMoney(price_min) ?? ''}</CardPrice>;
};

Price.propTypes = {
  hit: PropTypes.object.isRequired
};

export default Price;
